import type { MetricId } from './kom';

/**
 * What each term of the console means, in the console's own words (item 5). One place, so a metric,
 * a stage or a column says the same thing wherever it appears. The Overview's ten metrics are
 * here; stages, Sankey nodes, feed states and risk columns join in the weeks that rebuild them.
 */
export interface Definition {
  term: string;
  text: string;
}

export const METRIC_DEFINITIONS: Record<MetricId, Definition> = {
  incidents: {
    term: 'Active Incidents',
    text: 'Incidents that are open right now and not yet remediated. The bar splits them by risk.',
  },
  queue: {
    term: 'My Queue',
    text: 'Remediations waiting for you to approve or reject before they run. Oldest waiting is how long the longest one has been there.',
  },
  alerts: {
    term: 'Alerts Ingested',
    text: 'Security alerts received from your connected sources in the chosen period. Deduplicated alerts repeat one already seen; in transit ones are still waiting to be analysed.',
  },
  assign: {
    term: 'Mean Time to Assign',
    text: 'The typical time from a remediation being formed until it is assigned, over those finished in the chosen period. p90 is the time that 9 in 10 of them beat.',
  },
  triage: {
    term: 'Mean Time to Triage',
    text: 'The typical time from a remediation being assigned until a person decides on it. Only gated remediations finished in the chosen period count.',
  },
  remediate: {
    term: 'Mean Time to Remediate',
    text: 'The typical time from the decision until the remediation is verified, over those finished in the chosen period.',
  },
  resolve: {
    term: 'Mean Time to Close',
    text: 'The typical time from the first alert of an incident until it is closed, over those closed in the chosen period.',
  },
  suppression: {
    term: 'False Positive Suppression',
    text: 'Alerts the system judged harmless in the chosen period and did not raise as threats. Open the Resolved view to review them.',
  },
  autoResolution: {
    term: 'Auto-Resolution Rate',
    text: 'The share of closed remediations that ran by themselves, without waiting for a person.',
  },
  integrations: {
    term: 'Integration Health',
    text: 'How many connected sources are working with no error, out of all connected sources. Worst lag is the longest time since a source last reported.',
  },
};
